export default function() {

	let lazyImages = [].slice.call(document.querySelectorAll(".lazy"));
	// console.log('lazyImages : ', lazyImages);
	let active = false;

	const lazyLoad = function() {
		if (active === false) {
			active = true;

			setTimeout(function() {
				lazyImages.forEach(function(lazyImage) {
					// console.log('lazyImage : ', lazyImage, lazyImage.dataset);

					if (lazyImage.nodeName === 'SOURCE') {

						lazyImage.srcset = lazyImage.dataset.srcset;

					} else if (lazyImage.nodeName === 'IMG') {

						lazyImage.src = lazyImage.dataset.src;
					}


					lazyImage.classList.remove("lazy");

					lazyImages = lazyImages.filter(function(image) {

						return image !== lazyImage;
					});

					if (lazyImages.length === 0) {

						lazyLoad();
					}
				});

				active = false;
			}, 200);
		}
	};

	$('#showModalGallery').on('click', function(event) {
		event.preventDefault();

		lazyLoad();

		$('#modalGallery').modal('show');
	});
	
	$("#modalGallery .modal-dialog").on("click", function(event) {
		event.preventDefault();
		
		if(event.target.classList.contains("modal-dialog")) {
			$('#modalGallery').modal('hide');
		}
	})
}
